<!--历史工单列表查询-->
<template>
  <div class="historyOrderList">
    <div class="con">
      <div class="Files-top">
        <div class="ic-left">
          <span>历史工单列表</span>
        </div>
        <div class="btns">
        </div>
      </div>
      <div class="search-input-btn">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="public-f">
            <div class="input-small">
              <span>开始时间：</span>
              <el-date-picker style="width:2rem" v-model="startTime" type="datetime" clearable placeholder="选择日期时间"
                align="right" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div class="input-small " style="margin:0px 0.2rem;">
              <span>截止时间：</span>
              <el-date-picker style="width:2rem" v-model="endTime" type="datetime" clearable placeholder="选择日期时间"
                align="right" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div class="input-small myinput">
              <span>工单分组：</span>
              <el-select v-model="myvalue1" placeholder="请选择" clearable style="width:1.6rem" @change="orderGroup_fn">
                <el-option v-for="item in $store.orderGroupStore.getters.getOrderGroupTree" :key="item.id"
                  :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput" style="margin:0px 0.2rem;">
              <span>工单状态：</span>
              <el-select v-model="myvalue2" placeholder="请选择" clearable style="width:1.6rem" @change="state_fn">
                <el-option v-for="item in $store.orderStore.state.realStateList" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput">
              <span>工单类型：</span>
              <el-select v-model="myvalue3" placeholder="请选择" clearable style="width:1.6rem" @change="state_fn">
                <el-option v-for="item in $store.orderGroupStore.state.orderDefineList" :key="item.value"
                  :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput" style="margin-left:0.2rem;">
              <span>优先级：</span>
              <el-select v-model="myvalue4" placeholder="请选择" clearable style="width:1.6rem" @change="priority_fn">
                <el-option v-for="item in $store.orderGroupStore.state.priorityList" :key="item.value"
                  :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" size="mini" plain @click="seachOrder" class="search-btn">查询</el-button>
          </div>
        </el-scrollbar>

      </div>
      <!-- <infoList  :style="{height: (openFilter ? 'calc(100% - 80px)':'calc(100% - 2.6rem)'),transition:'0.3s',padding:'0px 20px',background: '#fff'}" ref="infoList" @checkItem="nowOrder = $event" :columns='columns' :dataList="nowPage" :pageLen='pageLen' :totalSize="totalSize" @selectPage="selectPage" :fillAll="true">
			<div slot="control" slot-scope="slotProps" v-show="slotProps.item != undefined">
				<span class="intoButton" @click.stop="intoOrder(slotProps.item)" style="margin-right: 10px;color:#409eff">进入</span>
				<span class="intoButton" @click.stop="copyOrder(slotProps.item)" 
				v-show="slotProps.item != undefined && slotProps.item.creatorId == myId" style="margin-right: 10px;color:#409eff">克隆</span>
				<span class="intoButton" @click.stop="invalidOrder(slotProps.item)" 
				v-show="slotProps.item != undefined && slotProps.item.creatorId == myId" style="color:#f56c6c">删除</span>
			</div>
		</infoList> -->
      <el-table :data="tableData" v-loading="loading" stripe style="width: 100%" :max-height="heights">
        <template slot="empty">
          <span class="noData">
            <img src="@/assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column label="序号" width="90" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="单号" width="180"> </el-table-column>

        <el-table-column label="分组" width="100" align="center">
          <template #default="{row}">
            <div class="patrol public-flex" v-if="row.grouping =='巡检'">
              <p></p><span>{{row.grouping}}</span>
            </div>
            <div class="overhaul public-flex" v-if="row.grouping =='检修'">
              <p></p><span>{{row.grouping}}</span>
            </div>
            <div class="rush public-flex" v-if="row.grouping =='抢修'">
              <p></p><span>{{row.grouping}}</span>
            </div>
            <div class="public-flex" v-if="row.grouping =='未分组'">
              <span>{{row.grouping}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名称" width="180"> </el-table-column>
        <el-table-column prop="creatorName" label="创建人" width="100"> </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template #default="{row}">
            <span>{{status_format(row.status)}}</span>
          </template>
        </el-table-column>

        <el-table-column label="优先级" width="100" align="center">
          <template #default="{row}">
            <div class="public-flex">
              <p class="myemergent mutongyong" v-if="row.priority =='紧急'">{{(row.priority)}}</p>
              <p class="myhigh mutongyong" v-if="row.priority =='高'">{{(row.priority)}}</p>
              <p class="mystandard mutongyong" v-if="row.priority =='标准'">{{(row.priority)}}</p>
              <p class="mylow mutongyong" v-if="row.priority =='低'">{{(row.priority)}}</p>
              <p v-if="row.priority =='--'">--</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" width="160">
          <template #default="{row}">
            <span>{{row.createTime | date_format}}</span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" width="160">
          <template #default="{row}">
            <span>{{row.startTime | date_format}}</span>
          </template>
        </el-table-column>
        <el-table-column label="完成时间" width="160">
          <template #default="{row}">
            <span>{{row.endTime | date_format}}</span>
          </template>
        </el-table-column>
        <el-table-column label="最后编辑时间" width="160">
          <template #default="{row}">
            <span>{{row.updateTime | date_format}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right">
          <template #default="{row}">
            <span class="buttoned_box" style="display: flex;">
              <p @click="intoOrder(row)" style="color:#368ED9;">进入</p>
              <span class="line" v-show="row.creatorId == myId"></span>
              <p @click="copyOrder(row)" style="color:#368ED9;"
                v-show="row.creatorId == myId && row.status != 'Stopping'">克隆</p>
              <span class="line" v-show="row.creatorId == myId"></span>
              <p @click="invalidOrder(row)" style="color:#FF1D1D;" v-show="row.creatorId == myId">删除</p>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import infoList from '@/components/module/universal/infoList.vue'
  export default {
    components: {
      infoList,
    },
    props: {},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        myvalue1: "",
        myvalue2: "",
        myvalue3: "",
        myvalue4: "",
        loading: false,
        tableData: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        nowOrderDefine: undefined,
        nowStatus: undefined,
        nowPriority: undefined,
        nowFilter: {
          orderGroup: false,
          state: false,
          priority: false,
          orderDefine: false,
          startTime: false
        },
        openFilter: true,
        filterList: [{
          name: '工单分组',
          id: 'orderGroup'
        },{
          name: '工单状态',
          id: 'state'
        },{
          name: '优先级',
          id: 'priority'
        },{
          name: '工单类型',
          id: 'orderDefine'
        },{
          name: '开始时间',
          id: 'startTime'
        }],
        //当前选中的分组的id数组，单人版本只允许单个
        orderGroupIds: [],
        pageLen: 100,
        nowOrder: [],
        nowIndex: 0,
        orderListByIndex: [], //每一页的记录,修改查询内容后查询就会清空
        startTime: undefined,
        endTime: undefined,
        totalSize: 0,
        newOrderGroupIds: "",
        newstateIds: "",
        newPriorityIds: "",
        groupArr: [],
        priorityArr: [],
        realStateList: []
      }
    },
    created () {},
    mounted () {
      this.groupArr=this.$store.orderGroupStore.getters.getOrderGroupTree
      this.priorityArr=this.$store.orderGroupStore.state.priorityList
      this.realStateList=this.$store.orderStore.state.realStateList
      debugPage=this
      this.nowOrderDefine=this.$store.orderGroupStore.state.orderDefineList[0].value
      this.seachOrder()
    },
    destroyed () {},
    computed: {
      myId () {
        return this.$store.userStore.state.nowUserInfo.id
      },
      nowPage () {
        var list=this.orderListByIndex[this.nowIndex]
        if(list==undefined) {
          return []
        }
        return list
      },
      columns () {
        var baseList=[{
          name: '单号',
          key: 'orderId',
          weight: 1.2
        },{
          name: '名称',
          key: 'title',
          weight: 1.4,
        },{
          name: '创建人',
          key: 'creatorName'
        },{
          name: '分组',
          key: 'groupId',
          format: item => {
            return getValueIfNoNull(this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item),{
              name: '未分组'
            }).name
          }
        },{
          name: '优先级',
          key: 'groupId',
          format: item => {
            var group=this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item)
            if(group==undefined) {
              return '--'
            }
            var priority=this.$store.orderGroupStore.getters.getPriorityByValue(group.priority)
            return getValueIfNoNull(priority,{
              name: '--'
            }).name
          }
        },{
          name: '创建时间',
          key: 'createTime',
          format (item) {
            return new Date(item).formatByTime()
          },
          weight: 1.4,
        }]
        baseList.insert(2,{
          name: '状态',
          key: 'status',
          format: item => {
            return this.$store.orderStore.getters.getStateNameByStatus(item)
          }
        })
        baseList.push({
          name: '开始时间',
          key: 'startTime',
          format (item) {
            return new Date(item).formatByTime()
          },
          weight: 1.4,
        })
        baseList.push({
          name: '完成时间',
          key: 'endTime',
          format (item) {
            return new Date(item).formatByTime()
          },
          weight: 1.4,
        })
        baseList.push({
          name: '最后编辑时间',
          key: 'updateTime',
          format (item) {
            return new Date(item).formatByTime()
          },
          weight: 1.4,
        })
        baseList.push({
          name: '操作',
          type: 'slot',
          key: 'control'
        })
        return baseList
      }
    },
    watch: {},
    methods: {
      //新操作筛选
      orderGroup_fn (item) {
        this.newOrderGroupIds=item
        this.orderGroupIds=[item]
      },
      //工单状态
      state_fn (item) {
        this.newstateIds=item
        this.nowStatus=item
      },
      //优先级
      priority_fn (item) {
        this.newPriorityIds=item
        this.nowPriority=item
      },

      //分组
      group_format (val) {

        var index=this.groupArr.findIndex(item => item.groupId==val)
        if(index==-1) {
          return "未分组"
        } else {
          return this.groupArr[index].name
        }
      },
      //状态
      status_format (val) {

        return this.$store.orderStore.getters.getStateNameByStatus(val)
      },
      //优先级
      priority_format (val) {
        var group=this.$store.orderGroupStore.getters.getOrderGroupByGroupId(val)
        if(group==undefined) {
          return '--'
        }
        var index=this.priorityArr.findIndex(item => item.value==group.priority)
        if(index==-1) {
          return "--"
        } else {
          return this.priorityArr[index].name
        }
      },

      selectPage (index) {
        this.nowIndex=index
        if(isempty(this.nowPage)) {
          this.seachOrder()
        }
      },
      seachOrder () {
        //个人版只能查询部分内容
        var creatorIds=undefined
        var nodeUsers=undefined
        var participants=undefined
        this.loading=true
        switch(this.nowOrderDefine) {
          case 'all':
            break
          case 'copyToMe':
            participants=this.myId
            break
          case 'iCreated':
            creatorIds=this.myId
            break
          case 'myNode':
            nodeUsers=this.myId
            break
        }
        //排除多余的检查项
        var orderGroupIds=undefined
        if(this.orderGroupIds.length!=0) {
          orderGroupIds=this.orderGroupIds.join(',')
        }
        var nowStatus=undefined
        if(this.newstateIds) {
          nowStatus=this.newstateIds
        } else {
          nowStatus="BreakOff,Done,OvertimeDone"
        }
        var nowPriority=undefined
        if(this.newPriorityIds) {
          nowPriority=this.newPriorityIds
        }

        var startTime=undefined
        if(this.startTime) {
          startTime=this.startTime.getTime()
        }
        var endTime=undefined
        if(this.endTime) {
          endTime=this.endTime.getTime()
        }
        //判断工单类型
        var orderType='Order'
        this.$api.orderApi.searchByType(this.nowIndex+1,this.pageLen,orderGroupIds,orderType,nowStatus,nowPriority,
          creatorIds,nodeUsers,participants,startTime,endTime,undefined,respon => {
            this.totalSize=respon.total
            this.tableData=respon.dataList
            this.tableData.forEach(item => {
              item.grouping=this.group_format(item.groupId)
              item.priority=this.priority_format(item.groupId)
            })

            this.loading=false
            this.$set(this.orderListByIndex,this.nowIndex,respon.dataList)
            if(orderType=='OrderTemplate') {
              this.$store.orderStore.commit('getOrderTemplateList')
            }
          })
      },
      intoOrder (order) {
        //进入工单
        this.$store.orderStore.commit('setNowOrder',order)
        this.$router.push('/dealOrder')
      },
      invalidOrder (order) {
        this.$dialogMethod.openAgreeDialog("删除工单","是否确定删除 "+order.title,() => {
          this.$api.orderApi.removeByOrderIds(order.orderId,respon => {
            if(respon.length>0) {
              this.$dialogMethod.showMessage('当前工单不允许被删除!')
            } else {
              this.nowOrder=[]
              this.seachOrder()
              var list=this.orderListByIndex[this.nowIndex]
              this.$set(list,list.findIndex(item => {
                return item.orderId==order.orderId
              }),order)
              this.$dialogMethod.showMessage('删除成功!')
            }
          })
        })
      },
      copyOrder (order) {
        //进入工单
        this.$store.orderStore.commit('setCopyOrderId',order.id)
        this.$router.push('/copyOrder')
      },
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
  }
</script>

<style scoped lang="scss">
  .historyOrderList {
    .con {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 12px 20px 20px 20px;
      box-sizing: border-box;

      .search-input-btn {
        width: 100%;
        height: 36px;

        .public-f {
          width: 100%;
          display: -webkit-box !important;
        }
      }

      .buttoned_box {
        display: flex;
        // justify-content: space-around;
        justify-content: center;
        align-items: center;

        .line {
          display: inline-block;
          width: 1px;
          height: 20px;
          background-color: #E6E6E6;
          margin: 0px 12px;
        }

        p {
          font-size: 14px;
          cursor: pointer;
        }


      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 巡检
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 检修
      .overhaul {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF9900;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF9900;
        }
      }

      // 抢修
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FD602E;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FD602E;
        }
      }

      .mutongyong {
        width: 36px;
        height: 22px;
        text-align: center;
        line-height: 22px;
      }

      //紧急
      .myemergent {
        color: #FF1D1D;
        background-color: #FFE7E7;
      }

      //高
      .myhigh {
        color: #BF458E;
        background-color: #FFE9F6;
      }

      //标准
      .mystandard {
        color: #5452C9;
        background-color: #E5E8FF;
      }

      //低
      .mylow {
        color: #2981D2;
        background-color: #DEF3FF;
      }
    }

  }
</style>